import React, { useState } from "react";
import { Container, Row, Col, Card, Input } from "reactstrap";

function ProductListingProduct(props) {

  const [productName, setProductName] = useState("");
  const [brand, setBrand] = useState("");
  const [gtin, setGtin] = useState("");
  const [sku, setSku] = useState("");

  const [searchResult, setSearchResult] = useState(null);

  const handleSearch = () => {

    // Later call backend API

    const mockResult = {
      asin: "B123XYZ456",
      title: "Nike Running Shoes"
    };

    setSearchResult(mockResult);
  };

  return (

    <Container>

      <Row>

        {/* Title */}

        <Col md={12} className="mt-4 mb-3">
          <h4>Step 2 : Product Identification</h4>
        </Col>


        {/* Product Details Card */}

        <Col md={12} className="ml-4 mr-4">

          <Card className="p-4">

            <Row className="mb-3">
              <Col md={4} className="amazon-listing-labels">Product Name : </Col>
              <Col md={8}>
                <Input
                  type="text"
                  value={productName}
                  onChange={(e) => setProductName(e.target.value)}
                />
              </Col>
            </Row>


            <Row className="mb-3">
              <Col md={4} className="amazon-listing-labels">Brand : </Col>
              <Col md={8}>
                <Input
                  type="text"
                  value={brand}
                  onChange={(e) => setBrand(e.target.value)}
                />
              </Col>
            </Row>


            <Row className="mb-3">
              <Col md={4} className="amazon-listing-labels">UPC / EAN / GTIN : </Col>
              <Col md={8}>
                <Input
                  type="text"
                  value={gtin}
                  onChange={(e) => setGtin(e.target.value)}
                />
              </Col>
            </Row>


            <Row className="mb-3">
              <Col md={4} className="amazon-listing-labels">SKU : </Col>
              <Col md={8}>
                <Input
                  type="text"
                  value={sku}
                  onChange={(e) => setSku(e.target.value)}
                />
              </Col>
            </Row>


            {/* Search Button */}

            <Row className="mt-3">

              <Col md={12} className="text-center">

                <button
                  className="btn btn-secondary"
                  onClick={handleSearch}
                >
                  Search Amazon Catalog
                </button>

              </Col>

            </Row>


            {/* Search Result */}

            {searchResult && (

              <Row className="mt-4 border-top pt-3">

                <Col md={12}>
                  <h6>Search Results</h6>
                </Col>

                <Col md={12}>
                  ✓ Matching Product Found
                </Col>

                <Col md={12}>
                  <b>ASIN : </b> {searchResult.asin}
                </Col>

                <Col md={12}>
                  {searchResult.title}
                </Col>

                <Col md={12} className="mt-3 text-center">

                  <button className="btn btn-dark mr-2">
                    Use Existing ASIN
                  </button>

                  <button className="btn btn-outline-secondary ml-2">
                    Create New Product
                  </button>

                </Col>

              </Row>

            )}

          </Card>

        </Col>


        {/* Navigation Buttons */}

        <Col md={12} className="mt-3 d-flex justify-content-between">

          <button
            className="btn btn-light"
            onClick={props.prevStep}
          >
            ← Back
          </button>

          <button
            className="btn btn-primary"
            onClick={props.nextStep}
          >
            Next →
          </button>

        </Col>

      </Row>

    </Container>

  );
}

export default ProductListingProduct;